export const TOPIC_LANGUAGES = [
  { code: 'fa', label: 'Persian', nativeLabel: 'فارسی' },
  { code: 'en', label: 'English', nativeLabel: 'English' },
  { code: 'ar', label: 'Arabic', nativeLabel: 'العربية' },
  { code: 'es', label: 'Spanish', nativeLabel: 'Español' },
  { code: 'fr', label: 'French', nativeLabel: 'Français' },
  { code: 'de', label: 'German', nativeLabel: 'Deutsch' },
  { code: 'pt', label: 'Portuguese', nativeLabel: 'Português' },
  { code: 'tr', label: 'Turkish', nativeLabel: 'Türkçe' },
  { code: 'ru', label: 'Russian', nativeLabel: 'Русский' },
  { code: 'zh', label: 'Chinese', nativeLabel: '中文' },
] as const;

export type TopicLanguageCode = (typeof TOPIC_LANGUAGES)[number]['code'];

export const DEFAULT_TOPIC_LANGUAGE: TopicLanguageCode = 'fa';

export function getTopicLanguageLabel(code: string): string {
  const match = TOPIC_LANGUAGES.find((l) => l.code === code);
  return match?.nativeLabel ?? code;
}
